import { render, staticRenderFns } from "./FAQs.vue?vue&type=template&id=9eb8d99c&"
import script from "./FAQs.vue?vue&type=script&lang=js&"
export * from "./FAQs.vue?vue&type=script&lang=js&"
import style0 from "./FAQs.vue?vue&type=style&index=0&id=9eb8d99c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports